import React, { useState } from 'react';
import { Box, Button, TextField, Typography, Paper, CircularProgress } from '@mui/material';
import axios from 'axios';
import { useLocation } from 'react-router-dom';
import { API_PATH } from '../../../App';

function useQuery() {
    return new URLSearchParams(useLocation().search);
}

function ResellerSetupPassword() {
    const query = useQuery();
    const token = query.get('token');
    
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [success, setSuccess] = useState(false);

    if (!token) {
        return (
            <Box display="flex" justifyContent="center" alignItems="center" height="100vh">
                <Typography color="error">Invalid or missing invitation token.</Typography>
            </Box>
        );
    }

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        setError('');
        
        if (password !== confirmPassword) {
            setError('Passwords do not match');
            return;
        }
        if (password.length < 6) {
            setError('Password must be at least 6 characters');
            return;
        }

        setLoading(true);
        try {
            await axios.post('/auth/reseller/accept-invite', {
                token: token,
                username: username,
                password: password
            });
            setSuccess(true);
        } catch (err: any) {
            console.error('Setup failed:', err);
            setError(err.response?.data?.message || err.response?.data || 'Failed to setup account');
        } finally {
            setLoading(false);
        }
    };

    if (success) {
        return (
            <Box display="flex" justifyContent="center" alignItems="center" height="100vh" bgcolor="#f5f5f5">
                <Paper elevation={3} style={{ padding: '2rem', textAlign: 'center', maxWidth: '400px' }}>
                    <Typography variant="h5" gutterBottom color="primary">Success!</Typography>
                    <Typography gutterBottom>Your Reseller account password has been setup successfully.</Typography>
                    <Button variant="contained" color="primary" onClick={() => window.location.href = '/'} style={{ marginTop: '1rem' }}>
                        Go to Login
                    </Button>
                </Paper>
            </Box>
        );
    }

    return (
        <Box display="flex" justifyContent="center" alignItems="center" height="100vh" bgcolor="#f5f5f5">
            <Paper elevation={3} style={{ padding: '2rem', maxWidth: '400px', width: '100%' }}>
                <Typography variant="h5" gutterBottom align="center">Setup Reseller Account</Typography>
                <Typography variant="body2" color="textSecondary" align="center" gutterBottom>
                    Please create a username and password for your account.
                </Typography>

                <form onSubmit={handleSubmit}>
                    <TextField
                        fullWidth
                        margin="normal"
                        label="Username"
                        value={username}
                        onChange={(e) => setUsername(e.target.value)}
                        required
                    />
                    <TextField
                        fullWidth
                        margin="normal"
                        label="New Password"
                        type="password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        required
                    />
                    <TextField
                        fullWidth
                        margin="normal"
                        label="Confirm Password"
                        type="password"
                        value={confirmPassword}
                        onChange={(e) => setConfirmPassword(e.target.value)}
                        required
                    />
                    
                    {error && (
                        <Typography color="error" variant="body2" style={{ marginTop: '0.5rem' }}>
                            {error}
                        </Typography>
                    )}

                    <Box mt={3}>
                        <Button 
                            fullWidth 
                            variant="contained" 
                            color="primary" 
                            type="submit" 
                            disabled={loading}
                        >
                            {loading ? <CircularProgress size={24} /> : 'Complete Setup'}
                        </Button>
                    </Box>
                </form>
            </Paper>
        </Box>
    );
}

export default ResellerSetupPassword;
